import React from "react";
import WalletTransactionsSearch from "./components/WalletTransactionsSearch";
import Wallet from "./components/WalletInfos";
import { TitleBar } from "../../../components/TitleBar";
import { useWallet } from "../../../hooks/useWallet";
import { useWalletTransactions } from "../../../hooks/useWalletTransactions";
import { WalletStatus } from "../../../store/slices/walletSlice";
import { WalletOtherActive } from "./components/WalletOtherActive";
import Loader from "../components/Loader";
import { SeedPhraseWarning } from "./components/SeedPhraseWarning";
import { WalletSyncing } from "./components/WalletSyncing";

interface WalletHistoryProps {
  
}

const WalletHistory: React.FC<WalletHistoryProps> = () => {
    const {status, shouldShowSeed} = useWallet();
    const {nbTxUnread} = useWalletTransactions();

    return (
        <div className="flex-1 px-4 pt-8 overflow-hidden flex flex-col gap-8 overflow-y-auto">
            <TitleBar title="Wallet" badgeMobile={nbTxUnread} />
            {
                status === WalletStatus.ACTIVE && (
                    shouldShowSeed ? (
                        <SeedPhraseWarning />
                    ) : (
                        <>
                            <Wallet />
                            <WalletTransactionsSearch />
                        </>
                    )
                )
            }
            {
                status === WalletStatus.OTHER_WALLET_ACTIVE && (
                    <WalletOtherActive />
                )
            }
            {
                status === WalletStatus.LOADING && (
                    <div className="flex flex-col items-center justify-center">
                        <Loader />
                    </div>
                )
            }
            {
                status === WalletStatus.SYNCING && (
                    <WalletSyncing />
                )
            }
        </div>
    );
}

export default WalletHistory;